<template>
  <div class="help-container">
    <div class="help-icon-container" id="helpIconContainer" @click="toggleHelpModal()">
      <help-circle-icon size="2.75x"></help-circle-icon>
    </div>
    <!--
    <b-popover target="helpIconContainer" variant="warning" triggers="hover" placement="topleft">
      <div>
        <p class="mb-0">Potrzebujesz pomocy? Kliknij, aby dowiedzieć się więcej!</p>
      </div>
    </b-popover>
    -->
    <help-modal></help-modal>
  </div>
</template>

<script>
import { HelpCircleIcon } from 'vue-feather-icons'
import HelpModal from './HelpModal'

export default {
  name: 'Help',

  data () {
    return {
      isActive: true
    }
  },

  methods: {
    toggleHelpModal () {
      this.isActive = !this.isActive
      if (this.isActive) this.$bvModal.hide('helpModal')
      else this.$bvModal.show('helpModal')
    }
  },

  components: { HelpCircleIcon, HelpModal }
}
</script>
